import CardPrayerDhuha from './CardPrayerDhuha';

export default CardPrayerDhuha;
